






























export default {
  name: "FilterCheckbox",
  props: {
    name: {
      type: String,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
    checked: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    isOnline() {
        if(this.filter.id === 'onlineAvailable') {
          return 'dOnlineAvailable';
        }
        return '';
    },
    isChecked() {
      return this.checked || this.$store.getters.isSelectedFilter(this.filter);
    },
    isDisabled() {
      return this.disabled || !this.isChecked && !this.$store.getters.filterMatchesAnyFilteredProduct(this.filter);
    },
  },
  methods: {
    handleInputChange(e: Event): void {
      this.$emit("change", e);
    },
  },
};
